<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <router-link v-if="hasOneShowingChildren(item.children) && !item.children[0].children&&!item.alwaysShow && !isNest" :to="item.path+'/'+item.children[0].path"
        :key="item.children[0].name">
        <el-menu-item :index="item.path+'/'+item.children[0].path" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="item.children[0].meta&&item.children[0].meta.icon" :icon-class="item.children[0].meta.icon"></svg-icon>
          <span v-if="item.children[0].meta&&item.children[0].meta.title" slot="title">{{item.children[0].meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <div @click="handleSubmenuClick(item)" style="width: 100%; height: 100%; cursor: pointer; display: flex; align-items: center;">
            <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
            <span v-if="item.meta&&item.meta.title">{{item.meta.title}}</span>
          </div>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[{...child, path: resolvePath(item.path, child.path)}]" :key="child.path"></sidebar-item>
          <!--支持外链功能-->
          <a v-else-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
            <el-menu-item :index="resolvePath(item.path, child.path)">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </a>
          <router-link v-else :to="resolvePath(item.path, child.path)" :key="child.name">
            <el-menu-item :index="resolvePath(item.path, child.path)">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    hasOneShowingChildren(children) {
      const showingChildren = children.filter(item => {
        return !item.hidden
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    resolvePath(basePath, path) {
      // console.log("resolvePath调用:", { basePath, path, isNest: this.isNest });
      
      // 如果是绝对路径，直接返回
      if (path.startsWith('/')) {
        // console.log("绝对路径:", path);
        return path;
      }
      
      // 对于嵌套路由，需要特殊处理
      if (this.isNest) {
        // 嵌套路由时，basePath可能已经是完整路径
        const result = basePath.endsWith('/') ? `${basePath}${path}` : `${basePath}/${path}`;
        // console.log("嵌套路由结果:", result);
        return result;
      }
      
      // 正常拼接
      const result = basePath.endsWith('/') ? `${basePath}${path}` : `${basePath}/${path}`;
      // console.log("正常拼接结果:", result);
      return result;
    },
    // 处理二级目录点击事件
    handleSubmenuClick(item) {
      // 点击目录只展开/折叠，不跳转到第一个子页面
      // 展开/折叠逻辑由父组件通过点击图标处理
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue